import { parseCookie } from 'cookie';

import { getAccessTokenFromOkapi } from './getAccessTokenFromOkapi';

export async function getOkapiAccessTokenFromCookies(cookieHeader: string | undefined, scope = 'vastgoed') {
  const parsedCookies = parseCookie(cookieHeader ?? '');
  const hasTokenInCookie = !!parsedCookies.token;
  const token = hasTokenInCookie && parsedCookies.token;
  const tokenResponse = !hasTokenInCookie && (await getAccessTokenFromOkapi(scope));

  return {
    token,
    tokenResponse,
    hasTokenInCookie,
  };
}
